import { UserNotificationPrefs } from './user-notification-prefs.model'
import { StaffProfile } from '../apps/profiles/models/StaffProfile';
import { GuardianProfile } from '../apps/profiles/models/GuardianProfile';
import { StudentProfile } from '../apps/profiles/models/StudentProfile';
import { PushNotificationDevice } from './PushNotificationDevice';
import { DeletableBaseModel } from './core-base.model';
import { Role } from '../apps/role-manager/role-manager.service';
import { UserTypeEnum } from './user-type.enum';
import { Language } from './language.model';

export class User extends DeletableBaseModel {
  UserTypeId: UserTypeEnum;
  OktaUserId: string;
  FirstName: string;
  LastName: string;
  FirstLastName: string;
  Email: string;
  Phone: string;
  LastContactDateTimeUTC: Date | null;
  UserGUID: string;
  ShowInDirectory: boolean;
  UseAvatar: boolean;
  ShowAI: boolean;
  ShowGuidedTour: boolean;
  IsTestAccount: boolean;
  LanguageId: number;

  // UserType: string; // TODO replace usage with UserTypeId + enum
  UserType: string;
  /** Search-result decorations (SearchForUsersAsync): staff position at the searched
   * school / student's current grade level. Not populated on other user payloads. */
  PositionDescription?: string | null;
  GradeLevel?: string | null;
  NotificationPrefs: UserNotificationPrefs;
  StaffProfile?: StaffProfile;
  GuardianProfile?: GuardianProfile;
  StudentProfile?: StudentProfile;
  AvatarPath: string;
  PushNotificationDevice: PushNotificationDevice;
  Roles: Role[];
  Language?: Language;
  IsImpersonating?: boolean;
  /** User Manager (analytics) decorations — populated by GetUsers only. */
  HouseholdStudents?: User[];
  HasSignedIn?: boolean;
  LoginDayCount?: number;
  LastLoginDateUTC?: Date | null;
  Devices?: UserDevice[];

  constructor(init?: Partial<User>) {
    super();
    Object.assign(this, init);
    this.UserType = UserTypeEnum.toString(this.UserTypeId);
  }
}

/** A device the user has logged in with (User Manager GetUsers only). */
export interface UserDevice {
  Platform: string;
  IsApp: boolean;
  /** Hardware model from the app (e.g. iPhone15,2); null for browsers. */
  Model: string | null;
  /** OS version from the most recent login; null for browsers. */
  OsVersion: string | null;
  LastLoginDateUTC: string;
  LoginCount: number;
}
